namespace Nobox.Nobox.Pages {
    export interface SendFormRequest {
        TnId?: number;
        FrmId?: number;
        FormResult?: NoBoxCRM.FormresultsRow;
    }
}
